import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

/**
 * Link and header link styling components
 */

export const SimpleLink = styled(Link)`
    font-size: 18px;
    line-height: 32px;
    text-align: left;
    text-decoration: none;
`

export const HeaderLink = styled(Link)`
    text-transform: unset;
    text-decoration: none;
`
